<!--<div class="flex flex-col rounded-lg p-6 gap-4">-->
<!--  <div class="flex flex-row justify-between items-center">-->
<!--    @if (data.copy) {-->
<!--      @if (data.filesToMove.length > 1) {-->
<!--        <span class="text-lg font-medium">{{data.filesToMove.length}} Dateien kopieren nach...</span>-->
<!--      }-->
<!--      @if (data.filesToMove.length == 1) {-->
<!--        <span class="text-lg font-medium">Datei kopieren nach...</span>-->
<!--      }-->
<!--    }-->

<!--    @if (!data.copy) {-->
<!--      @if (data.filesToMove.length > 1) {-->
<!--        <span class="text-lg font-medium">{{data.filesToMove.length}} Dateien verschieben nach...</span>-->
<!--      }-->
<!--      @if (data.filesToMove.length == 1) {-->
<!--        <span class="text-lg font-medium">Datei verschieben nach...</span>-->
<!--      }-->
<!--    }-->

<!--    <fa-icon (click)="cancelClicked()" [icon]="faX" class="text-gray-400 hover:cursor-pointer"></fa-icon>-->
<!--  </div>-->


<!--  <div class="flex flex-row w-full gap-2.5 items-center">-->
<!--    <fa-icon [icon]="faHouse" class="text-gray-700 text-sm"></fa-icon>-->
<!--    <span class="font-medium hover:cursor-pointer" (click)="navigateToSpecificFolder(undefined, 0)">Dateien</span>-->

<!--    <div class="flex flex-row w-full gap-2.5">-->
<!--      @for (i of [].constructor(currentDepth); track i; let j = $index) {-->
<!--        @if (this.parentDepthMap.has(j + 1)) {-->
<!--          <fa-icon [icon]="faChevronRight" class="text-gray-400"></fa-icon>-->
<!--          <span (click)="navigateToSpecificFolder(this.parentDepthMap.get(j+1)!, j+1)" class="font-medium hover:cursor-pointer"><span class="file-name" title="{{this.parentDepthMap.get(j+1)?.name}}">{{this.parentDepthMap.get(j+1)?.name}}</span></span>-->
<!--        }-->
<!--      }-->
<!--      @if (selectedRow) {-->
<!--        <fa-icon [icon]="faChevronRight" class="text-gray-400"></fa-icon>-->
<!--        <span class="font-medium hover:cursor-pointer"><span class="file-name" title="{{selectedRow.name}}">{{selectedRow.name}}</span></span>-->
<!--      }-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="flex flex-col rounded-lg border-gray-200 border">-->
<!--    @for (file of filteredData; track file; let i = $index) {-->
<!--      <div [class]="i == filteredData.length - 1 ? 'border-b-0' : 'border-b'"-->
<!--           [ngClass]="{-->
<!--    'bg-gray-100' : file.id == selectedRow?.id,-->
<!--    }" class="border-gray-100 flex flex-row items-center justify-between">-->
<!--        <div class="flex">-->
<!--          <fa-icon [icon]="faFolderOpen" class="text-green text-lg p-4"></fa-icon>-->
<!--          @if (currentParent != undefined) {-->
<!--            @if (file.id != currentParent!.id) {-->
<!--              <span (click)="navigateIntoFolder(file)" class="font-medium hover:cursor-pointer py-4"><span-->
<!--                class="file-name" title="{{file.name}}">{{ file.name }}</span></span>-->
<!--            }-->
<!--            @if (file.id == currentParent!.id) {-->
<!--              <span class="font-medium hover:cursor-pointer py-4"><span class="file-name"-->
<!--                                                                        title="{{file.name}}">{{ file.name }}</span></span>-->
<!--            }-->
<!--          }-->
<!--          @if (currentParent == undefined) {-->
<!--            <span (click)="navigateIntoFolder(file)" class="font-medium hover:cursor-pointer py-4"><span-->
<!--              class="file-name" title="{{file.name}}">{{ file.name }}</span></span>-->
<!--          }-->
<!--        </div>-->
<!--        @if (hasFolderChildren(file)) {-->
<!--          <fa-icon [icon]="faChevronRight" class="text-gray-900 px-4"></fa-icon>-->
<!--        }-->
<!--      </div>-->
<!--    }-->
<!--  </div>-->

<!--  <div class="flex flex-row items-center justify-end gap-4">-->
<!--    <bic-button (onClick)="cancelClicked()" buttonType="white" textColor="gray">Abbrechen</bic-button>-->
<!--    <bic-button [disabled]="checkIfMoveDisabled()" (onClick)="approveClicked()">{{ data.copy ? 'Kopieren' : 'Verschieben' }}</bic-button>-->
<!--  </div>-->
<!--</div>-->


<bic-popup
  [title]="data.copy ? (data.filesToMove.length > 1 ? (data.filesToMove.length + ' Dateien kopieren nach...') : 'Datei kopieren nach...') : (data.filesToMove.length > 1 ? (data.filesToMove.length + ' Dateien verschieben nach...') : 'Datei verschieben nach...')"
  (close)="cancelClicked()" customClass="w-[560px]">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (folderHint) {
      <span class="text-sm">{{ folderHint }}</span>
    }
    <div class="flex flex-row w-full gap-2.5 items-center">
      <fa-icon [icon]="faHouse" class="text-sm"
               [class]="currentDepth == 0 ? 'text-gray-900' : 'text-gray-400'"></fa-icon>
      <span class="font-medium hover:cursor-pointer" [class]="currentDepth == 0 ? 'text-gray-900' : 'text-gray-400'"
            (click)="navigateToSpecificFolder(undefined, 0)">Dateien</span>

      <div class="flex items-center overflow-hidden">
        <div
          class="flex items-center overflow-hidden whitespace-nowrap min-w-0" style="direction: rtl;">
          <div style="direction: ltr;" class="flex items-center gap-2 min-w-0">
            @for (i of [].constructor(currentDepth); track i; let j = $index) {
              @if (this.parentDepthMap.has(j + 1)) {
                <span class="flex items-center gap-2 min-w-0">
                  <fa-icon [icon]="faChevronRight" class="text-gray-400 flex-shrink-0"></fa-icon>
                  <span (click)="navigateToSpecificFolder(this.parentDepthMap.get(j+1)!, j+1)" [tooltip]="this.parentDepthMap.get(j + 1)?.name ?? ''" class="font-medium truncate hover:cursor-pointer" [class]="currentDepth == j+1 && !selectedRow ? 'text-gray-900' : 'text-gray-400'">
                    {{ this.parentDepthMap.get(j + 1)?.name }}
                  </span>
                </span>
              }
            }

            @if (selectedRow) {
              <span class="flex items-center gap-2 min-w-0">
                <fa-icon [icon]="faChevronRight" class="text-gray-400 flex-shrink-0"></fa-icon>
                <span class="font-medium text-gray-900 truncate" [tooltip]="selectedRow.name ?? ''">{{ selectedRow.name }}</span>
              </span>
            }
          </div>
        </div>
      </div>


    </div>

    <div class="flex flex-col rounded-lg border-gray-200 border">
      @for (file of filteredData; track file; let i = $index) {
        <div [class]="i == filteredData.length - 1 ? 'border-b-0' : 'border-b'"
             [ngClass]="{
    'bg-gray-100' : file.id == selectedRow?.id,
    }" class="border-gray-100 flex flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <fa-icon [icon]="faFolderOpen" class="text-green text-lg p-4"></fa-icon>
            @if (currentParent != undefined) {
              @if (file.id != currentParent!.id) {
                <span (click)="navigateIntoFolder(file)" class="font-medium hover:cursor-pointer py-4"><span
                  class="file-name" title="{{file.name}}">{{ file.name }}</span></span>
              }
              @if (file.id == currentParent!.id) {
                <span class="font-medium hover:cursor-pointer py-4"><span class="file-name"
                                                                          title="{{file.name}}">{{ file.name }}</span></span>
              }
            }
            @if (currentParent == undefined) {
              <span (click)="navigateIntoFolder(file)" class="font-medium hover:cursor-pointer py-4"><span
                class="file-name" title="{{file.name}}">{{ file.name }}</span></span>
            }
          </div>
          @if (hasFolderChildren(file)) {
            <fa-icon [icon]="faChevronRight" class="text-gray-900 px-4"></fa-icon>
          }
        </div>
      }
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button [disabled]="checkIfMoveDisabled()"
                (onClick)="approveClicked()">{{ data.copy ? 'Kopieren' : 'Verschieben' }}
    </bic-button>
  </div>
</bic-popup>
